import React, { Component, Fragment as F } from 'react'
import { connect } from 'react-redux'
// import store from './store'
import './public/css/errorPage.css'

import { logError } from './utils'

class ErrorHandler extends Component {
  constructor(props) {
    super(props)
    this.state = {
      error: false,
      errorInfo: null,
    }
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    if (process.env.REACT_APP_SERVER_URL.search(/(localhost|devapi)/gi) !== -1)
      console.log('EXCEPTION', error)
    return { error: true }
  }

  componentDidCatch(error, errorInfo) {
    // Something happened to one of my children.
    // Add error to state
    // console.log('EXCEPTION', error, errorInfo)
    this.setState({ error: true, errorInfo })
    const { user } = this.props
    logError({
      error: error.toString(),
      trace: errorInfo.componentStack,
      location: this.props.history ? this.props.history.location : window.location,
      user_id: user ? user._id : '',
    })
  }
  render() {
    const { user } = this.props
    if (this.state.error) {
      return (
        <F>
          <div className="error-502__container">
            <div className="error-502">
              <div className="error-502__text">
                <h1>Oops! Something went wrong</h1>
                <h2>
                  <p>
                    Go back to the <a href={user ? `/${user.user_type[0]}/home` : '/'}>Homepage</a>.
                  </p>
                  <p>
                    Or click to <a href="/">reload application</a>.
                  </p>
                </h2>
              </div>
            </div>
          </div>
          <div className="gears">
            <div className="gear one">
              <div className="bar"></div>
              <div className="bar"></div>
              <div className="bar"></div>
            </div>
            <div className="gear two">
              <div className="bar"></div>
              <div className="bar"></div>
              <div className="bar"></div>
            </div>
            <div className="gear three">
              <div className="bar"></div>
              <div className="bar"></div>
              <div className="bar"></div>
            </div>
          </div>
        </F>
      )
    }
    return this.props.children
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
})

export default connect(mapStateToProps, {})(ErrorHandler)
